import { useCoreQuery } from "../../core/hooks/use-core-query.js";
import { i18n } from "../../../utils/i18n.js";
import { useCurrentProductStore } from "../../core/hooks/use-current-product-store.js";
import { AccountSettings } from "../../account-settings/index.js";
import { LanguageList } from "../../languages/ui/list.js";
import { NotificationList } from "../../notifications/ui/list.js";
import { useMenu } from "../hooks/use-menu.js";
import { useMenuTour } from "../hooks/useMenuTour.js";
import { isValidFullUrl } from "../utils/url.js";
import "react";
import { jsx, jsxs } from "react/jsx-runtime";
import { Loading, Menubar, Skeleton, Tooltip, useDimensions } from "@tecsinapse/cortex-react";
import { clsx } from "clsx";
import { Link } from "react-router-dom";
import { BsMortarboard } from "react-icons/bs";
import { GoQuestion } from "react-icons/go";
//#region src/modules/menubar/ui/index.tsx
var getEmptyItem = (item) => {
	return [{ ...item }];
};
var Menu = ({ showLanguages, showNotifications, showMyAccount, customOptionsUser, version }) => {
	const { data: core, isLoading } = useCoreQuery();
	const { handleSearch, inputSearch, options, error, isLoading: isMenuLoading } = useMenu();
	const { width } = useDimensions();
	const ref = useMenuTour(core?.menuOnboardingSeen ?? true);
	const currentProduct = useCurrentProductStore((state) => state.currentProduct);
	return /* @__PURE__ */ jsx(Menubar.Root, { children: /* @__PURE__ */ jsxs("div", {
		ref,
		children: [/* @__PURE__ */ jsxs(Menubar.Header, {
			className: clsx("items-center", width <= 640 && "justify-start"),
			"aria-label": "Abrir Menu",
			children: [
				/* @__PURE__ */ jsx(Menubar.HeaderLeft, { children: /* @__PURE__ */ jsx("a", {
					href: core?.linkPortal,
					rel: "noreferrer",
					className: "cursor-pointer",
					children: isLoading ? /* @__PURE__ */ jsx(Skeleton, { className: "mx-kilo w-[250px] h-[70px] rounded-mili" }) : /* @__PURE__ */ jsx("img", {
						src: core?.brandImageUrl,
						alt: "brandLogo",
						className: "w-auto h-[70px] mx-kilo"
					})
				}) }),
				/* @__PURE__ */ jsx(Menubar.Search, {
					defaultValue: inputSearch,
					onChange: handleSearch,
					className: "flex-row items-center mx-deca hidden sm:flex"
				}),
				/* @__PURE__ */ jsx(Menubar.HeaderRight, {
					"aria-label": "Barra de ferramentas",
					children: /* @__PURE__ */ jsxs("div", {
						className: "flex items-center gap-x-deca",
						children: [
							core?.linkAcademia ? /* @__PURE__ */ jsx(Tooltip, {
								"aria-label": "Academia",
								text: i18n._(
									/** i18n */
									{ id: "MbVkgr" }
								),
								children: /* @__PURE__ */ jsx("a", {
									href: core?.linkAcademia,
									target: "_blank",
									rel: "noreferrer",
									children: /* @__PURE__ */ jsx(BsMortarboard, {
										className: "text-secondary-medium",
										size: 24
									})
								})
							}) : null,
							/* @__PURE__ */ jsx(Tooltip, {
								text: "Central de Relacionamento HelpTec",
								children: /* @__PURE__ */ jsx("a", {
									href: core?.linkHelpTec,
									target: "_blank",
									rel: "noreferrer",
									children: /* @__PURE__ */ jsx(GoQuestion, {
										className: "text-secondary-medium",
										size: 24
									})
								})
							}),
							showLanguages ? /* @__PURE__ */ jsx(LanguageList, { locales: core?.locales ?? [] }) : null,
							/* @__PURE__ */ jsx(NotificationList, { showNotifications: showNotifications ?? true }),
							/* @__PURE__ */ jsx(AccountSettings, {
								showMyAccount: showMyAccount ?? true,
								version,
								customOptionsUser,
								linkPortal: core?.linkPortal
							})
						]
					})
				})
			]
		}), /* @__PURE__ */ jsxs(Menubar.Dropdown, { children: [
			width < 640 ? /* @__PURE__ */ jsx(Menubar.Search, {
				defaultValue: inputSearch,
				onChange: handleSearch,
				className: "mb-deca"
			}) : null,
			error ? /* @__PURE__ */ jsx("p", { children: "Não foi possível carregar o menu :(" }) : null,
			isMenuLoading ? /* @__PURE__ */ jsx("div", {
				className: "flex items-center justify-center w-full",
				children: /* @__PURE__ */ jsx(Loading, { className: "w-[2rem] h-[2rem]" })
			}) : /* @__PURE__ */ jsx(Menubar.Categories, { children: options.map((item, idx) => /* @__PURE__ */ jsx(Menubar.Category, {
				title: item.label,
				options: item.children ?? getEmptyItem(item),
				render: ({ children, label, external, product, uri, baseUri }) => {
					if (!external && currentProduct === product && (baseUri.includes(location.hostname) || location.hostname.includes("localhost"))) return /* @__PURE__ */ jsx(Menubar.Item, {
						className: "flex flex-row items-center gap-x-deca",
						subItems: children ?? [],
						parentCategoryTitle: item.label,
						title: label,
						renderSubItems: ({ label: subItemLabel, uri: subItemUri }) => {
							return /* @__PURE__ */ jsx(Menubar.SubItem, { children: /* @__PURE__ */ jsx(Link, {
								to: String(subItemUri),
								className: "no-underline text-secondary-dark text-sub",
								children: String(subItemLabel)
							}) }, `${subItemLabel}-${idx}`);
						},
						children: (children ?? []).length > 0 ? /* @__PURE__ */ jsx("p", { children: String(label) }) : /* @__PURE__ */ jsx(Link, {
							to: String(uri),
							className: "no-underline text-secondary-dark",
							children: String(label)
						})
					}, `${label}-${idx}`);
					return /* @__PURE__ */ jsx(Menubar.Item, {
						anchorProps: {
							href: (children ?? []).length === 0 ? `${location.hostname.includes("localhost") && currentProduct === product || isValidFullUrl(String(uri)) ? "" : baseUri}${uri ?? ""}` : void 0,
							className: "no-underline",
							target: "_self"
						},
						className: "flex flex-row items-center gap-x-deca",
						subItems: children ?? [],
						parentCategoryTitle: item.label,
						title: label,
						renderSubItems: ({ label: subItemLabel, baseUri: subBaseUri, uri: subUri }) => {
							return /* @__PURE__ */ jsx(Menubar.SubItem, {
								anchorProps: {
									href: `${location.hostname.includes("localhost") && currentProduct === product ? "" : subBaseUri}${subUri ?? ""}`,
									className: "no-underline text-sub",
									target: "_self"
								},
								children: String(subItemLabel)
							}, `${subItemLabel}-${idx}`);
						},
						children: String(label)
					}, `${label}-${idx}`);
				}
			}, `${item.label}-${idx}`)) })
		] })]
	}) });
};
//#endregion
export { Menu };
